import { Route, Routes } from "react-router-dom";
import { useSelector } from "react-redux";
import Infant from "./pages/age/Infant";
import MinorConsent from "./pages/age/MinorConsent";
import MinorSoloTreatment from "./pages/age/MinorSoloTreatment";
import MinorWeight from "./pages/age/MinorWeight";
import ParentInstructions from "./pages/age/ParentInstructions";
import OtherState from "./pages/address/OtherState";
import Address from "./pages/address/Address";
import Insurer from "./pages/insurance/Insurer";
import InsureInfo from "./pages/insurance/InsureInfo";
import Concern from "./pages/Concern";
import Tried from "./pages/Tried";
import Prescription from "./pages/Prescription";
import Duration from "./pages/Duration";
import SexAtBirth from "./pages/sex/SexAtBirth";
import Maternity from "./pages/sex/Maternity";
import Menstrual from "./pages/sex/Menstrual";
import Allergies from './pages/Allergies';
import SelfPay from './pages/SelfPay';
import CardFile from './pages/insurance/CardFile';
import Photos from './pages/photos/Photos';
import Body from './pages/Body';
import OtherMeds from './pages/OtherMeds';
import HearAbt from './pages/HearAbt';
import AnythingElse from './pages/AnythingElse';
import FeelingNow from './pages/returning_patient/FeelingNow';
import PickedMedication from './pages/returning_patient/PickedMedication';
import PrescribedMedication from './pages/returning_patient/PrescribedMedication';
import HowWellWorks from './pages/returning_patient/HowWellWorks';
import StoppedMedication from './pages/returning_patient/StoppedMedication';
import FollowUpCare from "./pages/returning_patient/FollowUpCare";
import QuestionsForDoctor from "./pages/returning_patient/QuestionsForDoctor";
import DescribeSideEffects from "./pages/returning_patient/DescribeSideEffects";
import RecentPhoto from "./pages/returning_patient/RecentPhoto";
import ConfirmInsurance from "./pages/returning_patient/ConfirmInsurance";
import AnythingElseToKnow from "./pages/returning_patient/AnythingElseToKnow";
import ReturningLogin from "./pages/returning_patient/ReturningLogin";
import ReturningPatient from "./pages/returning_patient/ReturningPatient";
import ErrorPage from "./pages/ErrorPage";
import GA4TrackingComponent from "./components/GA4TrackingComponent";
import CaseDetails from "./pages/patient_portal/CaseDetails";
import CaseList from "./pages/patient_portal/CaseList";
import PatientCases from "./pages/returning_patient/PatientCases";
import MainLanding from "./pages/MainLanding";
import InsuranceDetailMethod from "./pages/InsuranceDetailMethod";
import InsurancePhoto from "./pages/insurance/InsurancePhoto";
import DefaultPage from "./pages/DefaultPage";
import UberDocLanding from "./pages/UberDocLanding";
import ZocDocLanding from "./pages/ZocDocLanding";
import LastPeriodDate from "./pages/accutane/LastPeriodDate";
import TreatmentContinuation from "./pages/accutane/TreatmentContinuation";
import SelfPayLanding from "./pages/SelfPayLanding";
import Demographic from "./pages/Demographic";
import Contraceptive from "./pages/sex/Contraceptive";
import WhatsNext from "./pages/WhatsNext";
import AppointmentSlots from "./pages/appointment/AppointmentSlots";
import AppointmentConfirm from "./pages/appointment/AppointmentConfirm";
import AppointmentBooking from "./pages/appointment/AppointmentBooking";
import AppointmentBookingPatients from "./pages/appointment/AppointmentBookingPatients";
import AppointmentThankYou from "./pages/appointment/AppointmentThankYou";
import PhotosPatientSelection from "./pages/photos/PhotosPatientSelection";
import PhotosLogin from "./pages/photos/PhotosLogin";
import PhotosCases from "./pages/photos/PhotosCases";
import PhotosThankYou from "./pages/photos/PhotosThankYou";
import ConcernChoice from "./pages/returning_patient/ConcernChoice";
import AppointmentList from "./pages/patient_portal/AppointmentList";
import LoginPage from "./pages/patient_portal/Login";
import LogoutRoute from "./pages/patient_portal/Logout";
import RequireAuth from "./hooks/RequireAuth";
import CaseThankYou from "./pages/patient_portal/CaseThankYou";
import CaseSelfThankYou from "./pages/patient_portal/CaseSelfThankYou";
import AbandonedIntake from "./pages/abandoned/AbandonedIntake";
import FireflyLanding from "./pages/FireflyLanding";
import InsuranceOptions from "./pages/returning_patient/InsuranceOptions";
import AppointmentReturningThankYou from "./pages/appointment/AppoointmentReturningThankYou";
import AppointmentExpectations from "./pages/appointment/AppointmentExpectations";
import MissedDoses from "./pages/accutane/MissedDoses";
import SideEffectsChecklist from "./pages/sex/SideEffectsChecklist";
import MedicalHistoryUpdates from "./pages/accutane/MedicalHistoryUpdates";
import Phq9Questionnaire from "./pages/accutane/Phq9Questionnaire";
import PatientHistoryMedical from "./pages/accutane/PatientHistoryMedical";
import PatientHistoryLifestyle from "./pages/accutane/PatientHistoryLifestyle";
import CaseIsotretinoinThankYou from "./pages/accutane/CaseIsotretinoinThankYou";
import PaymentSuccess from "./pages/payment/PaymentSuccess";
import PaymentCancel from "./pages/payment/PaymentCancel";

export default function CustomRoutes() {
  const user = useSelector((state) => state.user);

  return (
    <>
      <GA4TrackingComponent />
      <Routes>
        <Route path="/" element={<MainLanding />} />
        <Route path="/concern" element={<Concern />} />
        <Route path="/demographic" element={<Demographic />} />
        <Route path="/infant" element={<Infant />} />
        <Route path="/minor/consent" element={<MinorConsent />} />
        <Route path="/minor/solo-treatment" element={<MinorSoloTreatment />} />
        <Route path="/minor/weight" element={<MinorWeight />} />
        <Route path="/minor/instructions" element={<ParentInstructions />} />
        <Route path="/other-state" element={<OtherState />} />
        <Route path="/insurance/provider" element={<Insurer />} />
        <Route path="/insurance/method" element={<InsuranceDetailMethod />} />
        <Route path="/insurance/info" element={<InsureInfo />} />
        <Route path="/insurance/photos" element={<InsurancePhoto />} />
        <Route path="/whats-next" element={<WhatsNext />} />
        <Route path="/tried-before" element={<Tried />} />
        <Route path="/prescriptions" element={<Prescription />} />
        <Route path="/duration" element={<Duration />} />
        <Route path="/sex-at-birth" element={<SexAtBirth />} />
        <Route path="/maternity" element={<Maternity />} />
        <Route path="/menstrual" element={<Menstrual />} />
        <Route path="/contraceptive" element={<Contraceptive />} />
        <Route path="/allergies" element={<Allergies />} />
        <Route path="/payment" element={<SelfPay />} />
        <Route path="/card-file" element={<CardFile />} />
        {
          user.paid &&
          <>
            <Route path="/photos" element={<Photos />} />
            <Route path="/body-part" element={<Body />} />
            <Route path="/other-meds" element={<OtherMeds />} />
            <Route path="/anything-else" element={<AnythingElse />} />
            <Route path="/address" element={<Address />} />
            <Route path="/hear-abt" element={<HearAbt />} />
          </>}

        <Route path="/upload-photos" element={<PhotosLogin />} />
        <Route path="/photos-patients" element={<PhotosPatientSelection />} />
        <Route path="/photos-cases" element={<PhotosCases />} />
        <Route path="/photos-thank-you" element={<PhotosThankYou />} />

        {/* calendar appointment routes - maybe redux is better? */}
        <Route path="/appointment-booking" element={<AppointmentBooking />} />
        <Route path="/appointment-booking-patients" element={<AppointmentBookingPatients />} />
        <Route path="/appointment" element={<AppointmentSlots />} />
        <Route path="/appointment-confirm" element={<AppointmentConfirm />} />
        <Route path="/appointment-thank-you" element={<AppointmentThankYou />} />

        {/* returning patients routes */}
        <Route path="/returning" element={<ReturningLogin />} />
        <Route path="/returning-patient" element={<ReturningPatient />} />
        <Route path="/returning-reason" element={<ConcernChoice />} />
        <Route path="/patient-cases" element={<PatientCases />} />
        <Route path="/feeling-now" element={<FeelingNow />} />
        <Route path="/picked-medication" element={<PickedMedication />} />
        <Route path="/currently-prescribed" element={<PrescribedMedication />} />
        <Route path="/working-well" element={<HowWellWorks />} />
        <Route path="/stop-medication-reason" element={<StoppedMedication />} />
        <Route path="/follow-up-care" element={<FollowUpCare />} />
        <Route path="/questions-for-doctor" element={<QuestionsForDoctor />} />
        <Route path="/describe-side-effects" element={<DescribeSideEffects />} />
        <Route path="/recent-photo" element={<RecentPhoto />} />
        <Route path="/insurance-options" element={<InsuranceOptions />} />
        <Route path="/insurance-confirm" element={<ConfirmInsurance />} />
        <Route path="/anything-else-toknow" element={<AnythingElseToKnow />} />
        <Route path="/appointment-whats-next" element={<AppointmentExpectations />} />
        <Route path="/returning-appointment-thank-you" element={<AppointmentReturningThankYou />} />

        {/* patient portal routes  */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/logout" element={<LogoutRoute />} />
        <Route path="/case-list" element={<RequireAuth><CaseList /></RequireAuth>} />
        <Route path="/case-details/:patientID/:caseID" element={<RequireAuth><CaseDetails /></RequireAuth>} />
        <Route path="/appointment-list" element={<RequireAuth><AppointmentList /></RequireAuth>} />

        {/* thank you routes  */}
        <Route path="/self-thank-you" element={<CaseSelfThankYou />} />
        <Route path="/thank-you" element={<CaseThankYou />} />
        <Route path="/isotretinoin-thank-you" element={<CaseIsotretinoinThankYou />} />

        {/* intake routes */}
        <Route path="/uberdoc" element={<UberDocLanding />} />
        <Route path="/zocdoc" element={<ZocDocLanding />} />
        <Route path="/self" element={<SelfPayLanding />} />
        <Route path="/firefly" element={<FireflyLanding />} />

        {/* accutane routes */}
        <Route path="/acne-treatment" element={<TreatmentContinuation />} />
        <Route path="/patient-history-medical" element={<PatientHistoryMedical />} />
        <Route path="/patient-history-lifestyle" element={<PatientHistoryLifestyle />} />
        <Route path="/last-period-date" element={<LastPeriodDate />} />
        <Route path="/missed-doses" element={<MissedDoses />} />
        <Route path="/side-effects-checklist" element={<SideEffectsChecklist />} />
        <Route path="/medical-history-updates" element={<MedicalHistoryUpdates />} />
        <Route path="/phq9-questionnaire" element={<Phq9Questionnaire />} />

        {/* abandaned routes */}
        <Route path="/abandoned/:patientID" element={<AbandonedIntake />} />

        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />

        <Route path="/error" element={<ErrorPage />} />
        <Route path="*" element={<DefaultPage />} />
      </Routes>
    </>
  );
}
